import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

// Styles
import "./Alert.scss"

function Alert(props) {
  const { type, message = "", id, aria, additionalClasses } = props
  if (message.indexOf("href")) {
    return (
      <p
        role="alert"
        className={classNames(
          "Alert",
          `${type.toLowerCase()}-text`,
          additionalClasses
        )}
        {...(id && { id: `${id.toLowerCase()}-error` })}
        {...(aria &&
          aria.live && {
            "aria-live": aria.live,
          })}
        dangerouslySetInnerHTML={{
          __html: message,
        }}
      />
    )
  }
  return (
    <p
      role="alert"
      className={classNames(
        "Alert",
        `${type.toLowerCase()}-text`,
        additionalClasses
      )}
      {...(id && { id: `${id.toLowerCase()}-error` })}
      {...(aria &&
        aria.live && {
          "aria-live": aria.live,
        })}
    >
      {message}
    </p>
  )
}

Alert.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
  id: PropTypes.string,
  aria: PropTypes.object,
  additionalClasses: PropTypes.string,
}

export default Alert
